import { FETCH_USER, CLEAR_USER_DATA } from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = { requestStatus: statuses.idle, project: [] };

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_USER:
      return { ...state, requestStatus: statuses.succeeded, ...action.payload };
    case CLEAR_USER_DATA:
      return defaultState;
    default:
      return state;
  }
}
